<template>
  <v-container fluid>
    <v-row>
      <v-col cols="3">
        <v-card dark min-height="250" color="green ligthen-1">
          <v-card-title>Tipo de cambio</v-card-title>
          <v-card-subtitle
            ><label for="precioDolar"
              >¿A cuanto tomas el dólar?</label
            ></v-card-subtitle
          >
          <div class="config__input-container">
            <v-icon class="mr-2 mt-1" x-large>mdi-cash</v-icon>
            <input
              class="config__input config__input--lg"
              id="precioDolar"
              type="number"
              min="1"
              step="0.5"
              v-model="computedTipoCambio"
              @change="enableTipoCambioEdit"
            />
          </div>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              small
              class="mt-6"
              :disabled="isTipoCambioEditDisabled"
              @click="cancelEditTipoCambio"
            >
              <v-icon small class="mr-1">mdi-close-thick</v-icon>
              Cancelar</v-btn
            >
            <v-btn
              small
              class="mt-6"
              :disabled="isTipoCambioEditDisabled"
              @click="saveTipoCambio"
            >
              <v-icon small class="mr-1">mdi-floppy</v-icon>
              Guardar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
// const { updatePrecioDolar, getSettingByName } = api.services.settingsService;
export default {
  name: "CajaConfig",
  data() {
    return {
      tipoCambioSetting: null,
      tipoCambio: 1,
      isTipoCambioEditDisabled: true,
    };
  },
  computed: {
    ...mapGetters(["user"]),
    computedTipoCambio: {
      get: function () {
        return parseFloat(this.tipoCambio);
      },
      set: function (payload) {
        this.tipoCambio = parseFloat(payload);
      },
    },
  },
  methods: {
    ...mapActions(["showLoadingIndicator"]),
    updatePrecioDolar(){},
    getSettingByName(){},
    saveTipoCambio() {
      const self = this;
      self.showLoadingIndicator(true);
      const payload = this.makeTipoCambioPayload(this.computedTipoCambio);
      const savedTipoCambio = this.updatePrecioDolar(payload);
      setTimeout(() => {
        if (savedTipoCambio) {
          self.showLoadingIndicator(false);
          this.isTipoCambioEditDisabled = true;
          this.getTipoCambioFromDB();
        }
      }, 500);
    },
    cancelEditTipoCambio() {
      this.computedTipoCambio = parseInt(this.tipoCambioSetting.value);
    },

    enableTipoCambioEdit() {
      const tipoCambioFromSetting = parseFloat(this.tipoCambioSetting.value);
      const tipoCambioChanged =
        this.computedTipoCambio !== tipoCambioFromSetting;
      if (tipoCambioChanged) this.isTipoCambioEditDisabled = false;
      else this.isTipoCambioEditDisabled = true;
    },
    makeTipoCambioPayload(precioDolar) {
      const user = this.user;
      const payload = {
        idUsuario: user.id,
        name: "precio_dolar",
        value: precioDolar,
        context: "preferencias_negocio",
        description:
          "Decidir el tipo de cambio por  el dolar, es decir en cuanto (psesos MX) recibirlo",
      };
      return payload;
    },

    getTipoCambioFromDB() {
      const tipoCambioSetting = this.etSettingByName("precio_dolar");
      if (tipoCambioSetting) {
        this.tipoCambioSetting = tipoCambioSetting;
        this.computedTipoCambio = parseFloat(tipoCambioSetting.value);
      }
    },
  },
  beforeMount() {
    this.getTipoCambioFromDB();
  },
};
</script>